import {
  fhirApi,
  UpdateDefaultParameterPayload,
  UpdateDownloadSettingsPayload,
  UpdateListValueAccessPayload
} from '@/api/fhir.api';
import {
  CreateFHIRClientDownloadPermission,
  CreateFHIRClientParameterPermission,
  CreateFHIRClientPayload,
  GetFHIRRequestPayload,
  UpdateFHIRClientPayload
} from '@/views/AdminThirdPartyManagement/types/admin-fhir-access-management.types';
import { Store } from 'vuex';
import { FHIRState } from './types/fhir.types';

export const fhirActions = {
  async getDefaultParameters(store: Store<FHIRState>) {
    try {
      store.commit('GET_DEFAULT_PARAMETERS_LOADING');
      const { data } = await fhirApi.getDefaultParameters();
      store.commit('GET_DEFAULT_PARAMETERS_SUCCESS', data);
    } catch (error) {
      store.commit('GET_DEFAULT_PARAMETERS_ERROR', error);
    }
  },

  async updateDefaultParameter(
    store: Store<FHIRState>,
    { id, payload }: { id: number; payload: UpdateDefaultParameterPayload }
  ) {
    try {
      store.commit('UPDATE_DEFAULT_PARAMETER_LOADING');
      const { data } = await fhirApi.updateDefaultParameter(id, payload);
      store.commit('UPDATE_DEFAULT_PARAMETER_SUCCESS', data);
    } catch (error) {
      store.commit('UPDATE_DEFAULT_PARAMETER_ERROR', error);
    }
  },

  async updateDefaultParameterListValues(
    store: Store<FHIRState>,
    {
      id,
      listValues
    }: { id: number; listValues: UpdateListValueAccessPayload[] }
  ) {
    try {
      store.commit('UPDATE_DEFAULT_PARAMETER_LIST_VALUES_LOADING');
      const { data } = await fhirApi.updateDefaultParameterListValues(
        id,
        listValues
      );
      store.commit('UPDATE_DEFAULT_PARAMETER_LIST_VALUES_SUCCESS', {
        parameterId: id,
        listValues: data
      });
    } catch (error) {
      store.commit('UPDATE_DEFAULT_PARAMETER_LIST_VALUES_ERROR', error);
    }
  },

  async getDefaultDownloadPermissions(store: Store<FHIRState>) {
    try {
      store.commit('GET_DEFAULT_DOWNLOAD_PERMISSIONS_LOADING');
      const { data } = await fhirApi.getDefaultDownloadPermissions();
      store.commit('GET_DEFAULT_DOWNLOAD_PERMISSIONS_SUCCESS', data);
    } catch (error) {
      store.commit('GET_DEFAULT_DOWNLOAD_PERMISSIONS_ERROR', error);
    }
  },

  async updateDownloadSettings(
    store: Store<FHIRState>,
    payload: UpdateDownloadSettingsPayload
  ) {
    try {
      store.commit('UPDATE_DOWNLOAD_SETTINGS_LOADING');
      const { data } = await fhirApi.updateDownloadSettings(payload);
      store.commit('UPDATE_DOWNLOAD_SETTINGS_SUCCESS', data);
    } catch (error) {
      store.commit('UPDATE_DOWNLOAD_SETTINGS_ERROR', error);
    }
  },

  async getFhirClients(store: Store<FHIRState>, params: GetFHIRRequestPayload) {
    try {
      store.commit('GET_FHIR_CLIENTS_LOADING');
      const { data } = await fhirApi.getFhirClients(params);
      store.commit('GET_FHIR_CLIENTS_SUCCESS', data);
    } catch (error) {
      store.commit('GET_FHIR_CLIENTS_ERROR', error);
    }
  },

  async getFhirClientById(store: Store<FHIRState>, id: number) {
    try {
      store.commit('GET_FHIR_CLIENT_BY_ID_LOADING');
      const { data } = await fhirApi.getFhirClientById(id);
      store.commit('GET_FHIR_CLIENT_BY_ID_SUCCESS', data);
    } catch (error) {
      store.commit('GET_FHIR_CLIENT_BY_ID_ERROR', error);
    }
  },

  async createFhirClient(
    store: Store<FHIRState>,
    payload: CreateFHIRClientPayload
  ) {
    try {
      store.commit('CREATE_FHIR_CLIENT_LOADING');
      const { data } = await fhirApi.createFhirClient(payload);
      store.commit('CREATE_FHIR_CLIENT_SUCCESS', data);
    } catch (error) {
      store.commit('CREATE_FHIR_CLIENT_ERROR', error);
    }
  },

  async updateFhirClient(
    store: Store<FHIRState>,
    { id, payload }: { id: number; payload: UpdateFHIRClientPayload }
  ) {
    try {
      store.commit('UPDATE_FHIR_CLIENT_LOADING');
      const { data } = await fhirApi.updateFhirClient(id, payload);
      store.commit('UPDATE_FHIR_CLIENT_SUCCESS', data);
    } catch (error) {
      store.commit('UPDATE_FHIR_CLIENT_ERROR', error);
    }
  },

  async deleteFhirClient(store: Store<FHIRState>, id: number) {
    try {
      store.commit('DELETE_FHIR_CLIENT_LOADING');
      const { data } = await fhirApi.deleteFhirClient(id);
      store.commit('DELETE_FHIR_CLIENT_SUCCESS', data);
    } catch (error) {
      store.commit('DELETE_FHIR_CLIENT_ERROR', error);
    }
  },

  async updateClientParameters(
    store: Store<FHIRState>,
    {
      id,
      parameters
    }: { id: number; parameters: CreateFHIRClientParameterPermission[] }
  ) {
    try {
      store.commit('UPDATE_CLIENT_PARAMETERS_LOADING');
      const { data } = await fhirApi.updateClientParameters(id, parameters);
      store.commit('UPDATE_CLIENT_PARAMETERS_SUCCESS', data);
    } catch (error) {
      store.commit('UPDATE_CLIENT_PARAMETERS_ERROR', error);
    }
  },

  async updateClientDownload(
    store: Store<FHIRState>,
    { id, payload }: { id: number; payload: CreateFHIRClientDownloadPermission }
  ) {
    try {
      store.commit('UPDATE_CLIENT_DOWNLOAD_LOADING');
      const { data } = await fhirApi.updateClientDownload(id, payload);
      store.commit('UPDATE_CLIENT_DOWNLOAD_SUCCESS', data);
    } catch (error) {
      store.commit('UPDATE_CLIENT_DOWNLOAD_ERROR', error);
    }
  }
};
